var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TitleLine',{staticClass:"text-capitalize mb-2",attrs:{"title":_vm.title}}),_c('v-row',{attrs:{"align":"center","no-gutters":""}},_vm._l((_vm.composition.options),function(opt){
var _obj;
return _c('v-col',{key:opt,staticClass:"mr-2",attrs:{"cols":"auto"}},[_c('div',{class:[
          _vm.$style.bulletColor,
          'mb-2 p-1',
          ( _obj = {}, _obj[_vm.$style.bulletColorActive] = _vm.optSelected === opt, _obj ) ],on:{"click":function($event){return _vm.onSelect(opt)}}},[_c('div',{class:_vm.$style.bulletColorInner,style:({ backgroundColor: opt })})])])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }